import React, { useState } from "react";
import {
  Form,
  FormInstance,
  DatePicker,
  DatePickerProps,
  Radio,
  Col,
  Row,
} from "antd";
import styles from "./PersonForm.module.scss";
import { MomentInput } from "moment";
import moment from "moment";
import { LabelTypes } from "../../../hooks/usePersonForm";

type Props = {
  form: FormInstance;
  isEditProfile: boolean;
  labels?: LabelTypes;
};

const PersonDateOfBirth: React.FC<Props> = ({
  form,
  labels,
  isEditProfile,
}) => {
  const [displayError, setDisplayError] = useState<boolean>(false);

  const isValidDob = (dateOfBirth: MomentInput) =>
    dateOfBirth && moment().diff(dateOfBirth, "years") > 18;

  const handleDateChange: DatePickerProps["onChange"] = (date) => {
    const isAgeOver18 = form.getFieldValue("isAgeOver18");
    if (date && isValidDob(date)) {
      form.setFieldsValue({ dateOfBirth: date });
      setDisplayError(isAgeOver18 === "N");
    } else {
      form.setFieldsValue({ dateOfBirth: null });
      setDisplayError(isAgeOver18 === "N" || date !== null);
    }
  };

  const handleDateBlur: DatePickerProps["onBlur"] = (e: any) => {
    const dateOfBirth = e.target.value;

    if (dateOfBirth && !isValidDob(moment(dateOfBirth))) {
      setDisplayError(true);
      form.setFieldsValue({
        dateOfBirth: null,
      });
    }
  };

  function handleChange() {
    form.getFieldValue("isAgeOver18") === "N"
      ? setDisplayError(true)
      : setDisplayError(false);
  }

  const getPickerClassName = () => {
    const dateOfBirth = form.getFieldValue("dateOfBirth");

    if (dateOfBirth !== undefined) {
      return !isValidDob(dateOfBirth) ? `${styles.errorBorder}` : "";
    }
  };

  return (
    <>
      {!isEditProfile && (
        <>
          <Col span={24}>
            <Form.Item
              name="isAgeOver18"
              label={
                <div className={styles.label}>{labels?.isAgeOver18Label}</div>
              }
              className={styles.isAgeOver18FormItem}
            >
              <Radio.Group
                className={styles.radio}
                onChange={handleChange}
              >
                <Radio value="Y">Yes</Radio>
                <Radio value="N">No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          {displayError && (
            <div className={styles.errorMsg}>
              Service users must be at least 18 years old.
            </div>
          )}
        </>
      )}

      {isEditProfile && (
        <Col span={24} className={styles.label}>
          Date of Birth
        </Col>
      )}

      <Col span={24}>
        <Form.Item
          name="dateOfBirth"
          className={`${styles.datePickerFormItem} ${styles.formItemMargin}`}
        >
          <DatePicker
            className={getPickerClassName()}
            value={form.getFieldValue("dateOfBirth")}
            format="MM/DD/YYYY"
            placeholder="Date of Birth (MM/DD/YYYY)"
            onChange={handleDateChange}
            onBlur={(e) => handleDateBlur(e)}
          />
        </Form.Item>
      </Col>

      <Row gutter={[0, 10]}>
        <Col className={styles.optional}>**Optional</Col>
        <Col span={24} />
      </Row>

      {displayError && isEditProfile && (
        <Col span={24} className={styles.errorMsg}>
          Service users must be at least 18 years old.
        </Col>
      )}
    </>
  );
};

export default PersonDateOfBirth;
